import { useCallback, useEffect, useRef, useState } from "react";
import { Button, Input, Select, Space, message } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { commonApi, loginApi } from "@/apis";
import { Encrypt } from "@/utils/crypto";
import { useUserInfoDispath } from "@/model";
import Storage from "@/utils/store";
import { useNavigate } from "react-router";
import { env } from "@/utils/env";
// 样式写在调用处

const Account = () => {
  const timeRef = useRef<NodeJS.Timeout>();
  const productRef = useRef<any>();
  const dispatch = useUserInfoDispath();
  const navigate = useNavigate();

  const [allCompanyList, setAllCompanyList] = useState<
    ByUserNameOrPhoneUserInfoList[]
  >([]);
  const [companyOptions, setCompanyOptions] = useState<any[]>([]);
  const [productOptions, setProductOptions] = useState<any[]>([]);

  const [loading, setLoading] = useState(false);
  const [seloading, setSeloading] = useState(false);
  const [account, setAccount] = useState<string>();
  const [company, setCompany] = useState<string>();
  const [product, setProduct] = useState<string>();
  const [password, setPassword] = useState("");
  const [errInfo, setErrInfo] = useState({ show: false, err: "" });

  useEffect(() => {
    getDictTypeList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 获取字典
  const getDictTypeList = useCallback(() => {
    const _productList = Storage.l.get("productGroupDict");
    if (_productList) {
      productRef.current = _productList;
      return;
    }
    commonApi
      .getDictionaryList({
        dictTypeCodeList: ["product_group_shop"],
      })
      .then((res) => {
        const _product_group_shop = res?.product_group_shop || [];
        const productList: any = {};
        _product_group_shop.forEach((el) => {
          productList[el.dictCode] = el;
        });
        productRef.current = productList;
        Storage.l.set("productGroupDict", productList);
        dispatch({
          type: "user/setProductGroupDict",
          data: productList,
        });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 获取产品列表
  const getCompanyList = useCallback(async (curaccount: string) => {
    const _account = curaccount.trim();
    setProduct(undefined);
    setCompany(undefined);
    setCompanyOptions([]);
    setProductOptions([]);
    setAllCompanyList([]);
    if (!_account) return;
    setSeloading(true);
    const infoRes = await loginApi.getFindByUserNameOrPhone({
      userAccountOrPhone: _account,
    });
    setSeloading(false);
    if (!infoRes || infoRes.length === 0) {
      setErrInfo({
        show: false,
        err: "当前用户不存在，请检查账号是否有效",
      });
      return;
    }
    setErrInfo({
      show: false,
      err: "",
    });
    const companyList: any[] = [];
    infoRes.forEach(({ custName, custCode }) => {
      companyList.push({
        label: custName,
        value: custCode,
      });
    });
    // 一个默认选中
    if (infoRes.length === 1) {
      const { custCode, userVoList } = infoRes[0];
      setCompany(custCode);
      if (userVoList && userVoList.length) {
        const _productList: any[] = [];
        userVoList.forEach(({ userAccount, productGroup }) => {
          _productList.push({
            label: productRef.current[productGroup]?.dictValue,
            value: userAccount,
          });
        });
        setProductOptions(_productList);
      }
      if (userVoList.length === 1) {
        const { userAccount } = userVoList[0];
        setProduct(userAccount);
      }
    }
    setCompanyOptions(companyList);
    setAllCompanyList(infoRes);
  }, []);

  const handleChangeAccount = useCallback(
    (e: any) => {
      setAccount(e.target.value);
      clearTimeout(timeRef.current);
      timeRef.current = setTimeout(() => {
        getCompanyList(e.target.value);
      }, 1000);
    },
    [getCompanyList]
  );

  const handleSelectProduct = useCallback((e: string) => {
    setProduct(e);
  }, []);

  const handleChangeCompany = (e: string) => {
    const _curProInfo = allCompanyList.filter(
      ({ custCode }) => custCode === e
    )[0];
    const productList: any[] = [];
    _curProInfo.userVoList.forEach(({ userAccount, productGroup }) => {
      productList.push({
        label: productRef.current[productGroup]?.dictValue,
        value: userAccount,
      });
    });
    setCompany(e);
    setProduct(undefined);
    setProductOptions(productList);
  };

  const handleSubmitLgoin = () => {
    if (seloading) return;
    if (!account || !password) {
      return message.error("账号和密码不能为空");
    }
    if (errInfo.err) {
      setErrInfo({
        show: true,
        err: errInfo.err,
      });
      message.error(errInfo.err);
      return;
    }
    if (!product) {
      return message.error("请选择需要登录的公司和产品组");
    }
    setLoading(true);
    loginApi
      .fetchSubmitByAccount({
        account: Encrypt(product),
        password: Encrypt(password),
        appType: 2,
        type: 1,
        tenantCode: "default",
      })
      .then((res) => {
        const { success, errorMsg, data } = res;
        if (!success) {
          message.error(errorMsg);
          return;
        }
        const validcheck = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,16}$/;
        if (!validcheck.test(password)) {
          message.error("密码必须包含大小写字母、数字、特殊字符，长度8-16位");
          dispatch({
            type: "user/setTempJwt",
            data: data.jwt
          });
          dispatch({
            type: "login/close",
          });
          navigate("/reset")
          return;
        }

        let _accountListInfo = {};
        allCompanyList.forEach(({ userVoList }) => {
          userVoList.forEach((el) => {
            const { userAccount } = el;
            if (userAccount === product) {
              _accountListInfo = el;
            }
          });
        });

        // 登录信息，含有jwt等
        Storage.l.set("loginInfo", data);
        // 当前客户信息
        Storage.l.set("curUserInfo", _accountListInfo);
        dispatch({
          type: "user/setIsPhoneLogin",
          data: false
        });
        dispatch({
          type: "user/setUserInfo",
          loginInfo: data,
          curUserInfo: _accountListInfo,
        });
        dispatch({
          type: "login/close",
        });
        // 移动端
        if (env.isMobile) {
          message.success("登录成功");
          navigate("/home")
        }
      })
      .catch((err) => {
        message.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const forgetPass = useCallback(() => {
    dispatch({
      type: "login/close",
    });
    navigate("/forget");
  }, [dispatch, navigate]);

  return (
    <div className="account-login-wrapper">
      <p className="modal-label shop-pc">登录账号</p>
      <Input
        className="modal-item"
        size="large"
        placeholder="请输入账号"
        allowClear
        value={account}
        onChange={handleChangeAccount}
        prefix={<UserOutlined style={{ fontSize: "20px" }} />}
      />
      <p className="modal-label shop-pc">密码</p>
      <Input.Password
        value={password}
        className="modal-item"
        size="large"
        placeholder="请输入密码"
        onChange={(e) => {
          setPassword(e.target.value);
        }}
        prefix={<LockOutlined style={{ fontSize: "20px" }} />}
      />
      <p className="modal-label">关联的公司和产品组</p>
      <Space className="select-space" wrap>
        <Select
          loading={seloading}
          placeholder="请选择公司"
          style={{ width: "100%" }}
          value={company}
          onChange={handleChangeCompany}
          options={companyOptions}
        />
        <Select
          loading={seloading}
          placeholder="请选择产品组"
          value={product}
          style={{ width: "100%" }}
          onChange={handleSelectProduct}
          options={productOptions}
        />
      </Space>
      <div className="tips-wrapper">
        <span className="forget pointer" onClick={forgetPass}>
          忘记密码
        </span>
      </div>
      <Button
        type="primary"
        style={{ width: "100%" }}
        onClick={handleSubmitLgoin}
        loading={loading}
      >
        确定
      </Button>
    </div>
  );
};

export default Account;
